import Vue from "vue";

export default {
  signOut({ commit }) {
    return Vue.api
      .post("/users/signout")
      .catch((err) => {
        console.error(err);
        throw err;
      })
      .finally(() => {
        commit("AUTH_LOGOUT");
      });
  },

  loadConcepts({ commit }) {
    return Vue.api
      .get("/concepts", { params: { archived: false } })
      .then((res) => {
        commit("CONCEPTS", res.data);
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },

  loadMerchants({ commit }) {
    return Vue.api
      .get("/merchants")
      .then((res) => {
        commit("MERCHANTS", res.data);
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },

  loadInvoiceSeries({ commit }) {
    return Vue.api
      .get("/invoice-series")
      .then((res) => {
        commit("INVOICE_SERIES", res.data);
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },

  loadRightAccessSettings({ commit }) {
    return Vue.api
      .get("/right-access/all")
      .then((res) => {
        commit("RIGHT_ACCESS_SETTINGS", res.data);
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },

  saveUserSshKeys(_, payload) {
    return Vue.api
      .put("/clients", {
        sshKeys: payload,
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },
};
